import React from "react";
import { CircleLogo } from "web/react/emo/circle-logo";
import { Heading } from "web/react/emo/heading";
import { Text } from "web/react/emo/text";
import { View } from "web/react/emo/view";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { StoresSerializer } from "web/types/serializers";
import * as styles from "./stores.css";

export function StoresPage({ retailers }: StoresSerializer): React.ReactElement {
    const sendAnalyticsEvent = (retailerNetwork: string): void => {
        analytics.event({
            category: "shopfronts_button",
            action: "clicked",
            customData: { retailer_network: retailerNetwork },
        });
    };

    return (
        <View className={styles.layoutContainer}>
            <Heading as="h1" textStyle="hero">
                {gettext("stores_page.title")}
            </Heading>
            <div className={styles.grid}>
                {retailers.map(({ name, url, image_url, retailer_network }) => (
                    <a
                        key={url || name}
                        href={url}
                        className={styles.retailer}
                        onClick={() => sendAnalyticsEvent(retailer_network)}
                    >
                        <div className={styles.logo}>
                            <CircleLogo size="xxl" name={name} imageURL={image_url || undefined} />
                        </div>
                        <Text as="p" textStyle="body" align="center">
                            {name}
                        </Text>
                    </a>
                ))}
            </div>
        </View>
    );
}
